"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var DataCatalogProvider_1 = require("../../wrappers/DataCatalogProvider");
var FlowLineageSubplace_1 = require("./FlowLineageSubplace");
function EmbeddableFlowSubplaceWithoutRouter(props) {
    return (React.createElement(DataCatalogProvider_1.DataCatalogProvider, { client: props.client, siteUrls: props.siteUrls, apiRequests: props.apiRequests, uiActions: props.uiActions },
        React.createElement(FlowLineageSubplace_1.FlowLineageSubplaceRouter, { flowVizportalUrlId: props.flowVizportalUrlId })));
}
exports.EmbeddableFlowSubplaceWithoutRouter = EmbeddableFlowSubplaceWithoutRouter;
function EmbeddableFlowSubplaceWithRouter(props) {
    return (React.createElement(DataCatalogProvider_1.DataCatalogProviderWithRouter, { client: props.client, siteUrls: props.siteUrls, apiRequests: props.apiRequests, uiActions: props.uiActions },
        React.createElement(FlowLineageSubplace_1.FlowLineageSubplaceRouter, { flowVizportalUrlId: props.flowVizportalUrlId })));
}
exports.EmbeddableFlowSubplaceWithRouter = EmbeddableFlowSubplaceWithRouter;
//# sourceMappingURL=EmbeddableFlowSubplace.js.map